import { AppProvider } from 'app/provider';

import { PlatformRouter } from './router';

export const App = () => {
    return (
        <AppProvider>
            <PlatformRouter />
        </AppProvider>
    );
};
